import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class PromoHandlerService {

    constructor(
        private http: HttpClient,
        private auth: AuthService
    ) {
    }

    get localPromoCode(): any {
        return typeof localStorage.getItem('prC') !== 'undefined' ? localStorage.getItem('prC') : null;
    }

    set localPromoCode(prop: any) {
        if (prop) {
            localStorage.setItem('prC', prop);
        } else {
            localStorage.removeItem('prC');
        }
    }

    applyPromo(data: {
                   plan_id: string,
                   discount_id: string
               },
               apiUrl: string) {
        return this.http.post(`${apiUrl}/discount`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`,
                },
                responseType: 'text'
            });
    }
}
